/**
 * Path helpers for embed surfaces.
 *
 * Kept tiny and catalog-free so `next.config.ts` and `src/proxy.ts` can import
 * them without pulling the style inventory into the edge bundle.
 */

const WIDGET_PATH = /\/embed\/widget(?:\/|$)/;
const STUDIO_PATH = /\/embed\/?$/;

/** Locale-prefixed or unprefixed widget renderer, never the studio. */
export function isEmbedWidgetPath(pathname: string): boolean {
  return WIDGET_PATH.test(pathname);
}

/** The public Embed Studio page (`/en/embed`), not a widget. */
export function isEmbedStudioPath(pathname: string): boolean {
  return STUDIO_PATH.test(pathname) && !isEmbedWidgetPath(pathname);
}
